import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User, UserState } from '../../../shared/types';

const initialState: UserState = {
  currentUser: null,
  isAuthenticated: false,
  loading: true, // Commencer en mode chargement pour attendre la restauration de session
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setLoading: (state: UserState, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setUser: (state: UserState, action: PayloadAction<User | null>) => {
      state.currentUser = action.payload;
      state.isAuthenticated = !!action.payload;
    },
    setError: (state: UserState, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearError: (state: UserState) => {
      state.error = null;
    },
    logout: (state: UserState) => {
      state.currentUser = null;
      state.isAuthenticated = false;
    },
    updateUser: (state: UserState, action: PayloadAction<Partial<User>>) => {
      if (state.currentUser) {
        state.currentUser = { ...state.currentUser, ...action.payload };
      }
    },
    setAuthenticated: (state: UserState, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
  },
});

export const {
  setLoading,
  setUser,
  setError,
  clearError,
  logout,
  updateUser,
  setAuthenticated,
} = userSlice.actions;

export default userSlice.reducer;

